import * as types from './types';
import SignBookTransformer from '@/transformers/SignBookTransformer';

export default {
  [types.SET_SIGNBOOK](state, value) {
    state.signBook = value;
  },
  [types.SET_SIGNWORKFLOWS](state, values) {
    state.signworkflows = SignBookTransformer.fetchCollection(values.signbooks);
    state.nbSignbooks = values.nbSignbooks;
    let total;
    if (values.nbSignbooks % state.searchParams.limit || parseInt(values.nbSignbooks) === 0) {
      total = Math.floor((values.nbSignbooks / state.searchParams.limit) + 1);
    } else {
      total = Math.floor((values.nbSignbooks / state.searchParams.limit));
    }
    state.pagination = {
      current: ((state.searchParams.offset + state.searchParams.limit) / state.searchParams.limit),
      total,
    };
  },
  [types.RESET_SIGNWORKFLOWS](state) {
    state.signworkflows = {};
    state.nbSignbooks = undefined;
    state.pagination = { current: 1, total: 1 };
  },
  [types.SET_SIGNWORKFLOWS_SEARCH_PARAMS](state, value) {
    state.searchParams = JSON.parse(JSON.stringify(value));
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/parapheurs/mutations.js